import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import {
  Skeleton,
  Typography,
} from '@beeline/design-system-react/extracted-styles';

import { readSpace } from 'src/api/spaces';
import { SpaceInfo } from 'src/api/types';
import { messagesActions } from 'src/store/messages/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { defaultServerError } from 'src/utils/consts';

import classes from './SpaceInfo.module.scss';

export interface SpaceInfoProps {
  spaceId: number;
  testId?: string;
}

export const SpaceInfoComponent: FC<SpaceInfoProps> = ({ spaceId, testId }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);

  const [space, setSpace] = useState<SpaceInfo | undefined>();

  const getSpace = useCallback(async () => {
    try {
      setLoading(true);
      const response = await readSpace(spaceId);
      setSpace(response);
    } catch (e) {
      dispatch(messagesActions.show({ message: defaultServerError }));
    } finally {
      setLoading(false);
    }
  }, [dispatch, spaceId]);

  useEffect(() => {
    getSpace();
  }, [getSpace]);

  const title = useMemo(() => {
    const organization = space?.organizations[0];
    const parentOrganization = organization?.parent;
    let result = organization?.name ?? 'Подразделение';
    if (parentOrganization?.name) result += ` / ${parentOrganization.name}`;
    return result;
  }, [space?.organizations]);

  return loading ? (
    <Skeleton
      className={classes.title}
      data-testid={`${testId}TitleSkeleton`}
    />
  ) : (
    <Typography variant='body3' data-testid={`${testId}Organization`}>
      {title}
    </Typography>
  );
};
